const constants = {
  navbarWidth: '64px',
  navbarHeight: '80px',
  mainMenuBarWidth: '200px',
  subMenuBarWidth: '230px',
};

export default constants;
